import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { PlacementCategory } from '@core/models/placement-category.model';
import { Logger } from '@core/services/logger.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
	selector: 'cass-order-select-placement-category',
	templateUrl: './select-placement-category.component.html',
	styleUrls: ['./select-placement-category.component.css']
})
export class SelectPlacementCategoryComponent implements OnInit, OnDestroy {

	private readonly COMPONENT_NAME = "SelectPlacementCategoryComponent";

	@Input()
	placementCategories?: PlacementCategory[];

	@Input()
	selectedPlacementCategory?: PlacementCategory;

	@Output()
	placementCategoryChanged = new EventEmitter<PlacementCategory>();

	private placementCategorySelectedSubject = new Subject<PlacementCategory>();
	private subscription: Subscription = Subscription.EMPTY;

	constructor(
		private logger: Logger) {
	}

	ngOnInit(): void {
		this.subscription = this.placementCategorySelectedSubject.pipe(debounceTime(300)).subscribe((placementCategory) => {
			this.placementCategoryChanged.emit(placementCategory);
		});
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	selectPlacementCategory(placementCategory: PlacementCategory) {
		this.logger.debug(this.COMPONENT_NAME, `Selecting placementCategory id="${placementCategory?.id}" label="${placementCategory?.label}"`);
		this.selectedPlacementCategory = placementCategory;

		this.placementCategorySelectedSubject.next(this.selectedPlacementCategory);
	}
}
